module.exports = __webpack_public_path__ + "img/prod_icon_default@2x.20d89870.png";